import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { EntitySelector } from "./entitySelector";
/**
 * A primitive component with a ComboBox for selecting from existing scene materials.
 * @param props MaterialSelectorProps
 * @returns MaterialSelector component
 */
export const MaterialSelector = (props) => {
    MaterialSelector.displayName = "MaterialSelector";
    const { scene, ...rest } = props;
    const getMaterials = useCallback(() => scene.materials, [scene.materials]);
    const getName = useCallback((material) => material.name, []);
    return _jsx(EntitySelector, { ...rest, getEntities: getMaterials, getName: getName });
};
//# sourceMappingURL=materialSelector.js.map